import { useMutation } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import EmptyPageLoader from '../../../../components/EmptyPageLoader';
import TextInput from '../../../../components/input';
import SideDrawer from '../../../../components/SideDrawer';
import StyledButton from '../../../../components/StyledButton';
import useForm from '../../../../customHooks/useForm';
import useToast from '../../../../customHooks/useToast';
import { ADMIN_UPDATE_ROLES } from '../../../../graphql/admin_mutations';
import { GET_ALL_STAFF } from '../../../../graphql/admin_queries';
import useCustomQuery from '../../../../network/useCustomQuery';
import PlusIcon from '../../../../svgs/PlusIcon';
import { convertSpacesToHyphen } from '../../../../utils/helpers';
import Memebers from '../Memebers';
import Styles from './EditRole.module.scss';

interface IEditRole{
  onClose:()=>void;
  handleAddMemeber:any;
  payload:any;
  handleRemove:any;
  refetch:any;
}
const EditRole = ({
  onClose, handleAddMemeber, payload, handleRemove, refetch,
}:IEditRole) => {
  const Toast = useToast();
  const [getAllStaff, getAllStaffLoading, getStaffs] = useCustomQuery({
    query: GET_ALL_STAFF,
    onError: () => {},
    onData: () => {},
  });

  const [updateRolesRequest, { loading: updateRolesLoading }] = useMutation<
  { updateRole: any },
  any
>(ADMIN_UPDATE_ROLES);

  const [memebers, setMemebers] = useState(null);

  const fetchStaffs = () => {
    getAllStaff({
      variables: {
        roleId: payload?.id,
        limit: 100,
      },
    });
  };

  useEffect(() => {
    fetchStaffs();
  }, []);

  useEffect(() => {
    if (getStaffs?.getStaffs?.data) {
      setMemebers(getStaffs?.getStaffs?.data?.rows);
    }
  }, [getStaffs]);

  const {
    formValues, handleChange,
  } = useForm(
    {
      roleName: payload?.name,
      description: payload?.display_name,

    },
    {},
    Toast,
  );

  const handleUpdate = async () => {
    const data = {

      input: {
        name: convertSpacesToHyphen(formValues?.roleName)?.toLowerCase(),

        display_name: formValues?.description,

      },
      roleId: payload?.id,

    };

    if (!updateRolesLoading) {
      try {
        const res = await updateRolesRequest({
          variables: data,
        });

        if (res?.data?.updateRole && res?.data?.updateRole?.status === 200) {
          Toast.success(res?.data?.updateRole?.message || 'Operation was successful');

          onClose();
          refetch?.();
        } else {
          Toast.error(res?.data?.updateRole?.message || 'Operation failed');
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  return (
    <div className={Styles.wrapper}>
      <SideDrawer onClose={onClose} title="Edit Role" subtitle="You can edit user role here">
        {
          getAllStaffLoading ? <EmptyPageLoader /> : (
            <div className={Styles.wrapper__container}>
              {' '}
              <TextInput name="roleName" isRequired value={formValues?.roleName} label="User Role Name" customOnChange={handleChange} width="100%" />
              <TextInput name="description" multiline rows={4} isRequired value={formValues?.description} label="Description" customOnChange={handleChange} width="100%" />
              <div className={Styles.wrapper__memeberContainer}>
                {
                  memebers && <Memebers data={memebers} handleRemove={handleRemove} />
                }

              </div>
              <div className={Styles.wrapper__addNewTeam}>
                {' '}
                <span onClick={handleAddMemeber}>
                  <span><PlusIcon color="rgba(89, 65, 169, 1)" /></span>
                  {' '}
                  Add member

                </span>
              </div>
              <div className={Styles.wrapper__editPermissionBtn}>
                <StyledButton width="100%" name="Save Changes" backgroundColor="rgba(89, 65, 169, 1)" borderRadius="4px" border="none" padding="16px" color="white" fontWeight="600" disabled={updateRolesLoading || !formValues?.roleName || !formValues?.description} onClick={handleUpdate} loading={updateRolesLoading} />
              </div>
            </div>
          )
        }

      </SideDrawer>
    </div>
  );
};

export default EditRole;
